const routes = [
    {
        path: '/contabilidade/fiscal/exportar/:id',
        component: () => import('../views/ExportarFiscal'),
        meta: {
            title: 'Exportar Fiscal - Contabilidade'
        }
    },
]

export default routes
